import { render, staticRenderFns } from "./goutorbe.vue?vue&type=template&id=04f100eb&scoped=true"
import script from "./goutorbe.vue?vue&type=script&lang=js"
export * from "./goutorbe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f100eb",
  null
  
)

export default component.exports